var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZinzane({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9336 25.6954H9.49036V33.0823H10.9336V25.6954Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78487 26.5036V25.5375H0V26.8216H3.95039C2.62956 28.6439 1.32083 30.4661 0 32.2884V33.2545H5.94372V31.9704H1.99348C3.25316 30.1481 4.52519 28.3259 5.78487 26.5036Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.844 26.5036V25.5375H25.0591V26.8216H29.0095C27.6886 28.6439 26.3799 30.4661 25.0591 32.2884V33.2545H31.0029V31.9704H27.0526C28.3122 30.1481 29.5843 28.3259 30.844 26.5036Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0816 31.004L16.3881 25.7084H14.9451V33.0953H16.3881V28.24C17.5622 29.8544 18.7485 31.481 19.9226 33.0953H21.5248V25.7084H20.0816V31.004Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4824 31.004L45.7889 25.7084H44.3457V33.0953H45.7889V28.24C46.963 29.8544 48.1493 31.481 49.3234 33.0953H50.9254V25.7084H49.4824V31.004Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0718 25.5488H36.7878L33.7426 33.1191H35.3936L36.0906 31.2969H38.7935L39.4906 33.1191H41.1416L38.0963 25.5611L38.0718 25.5488ZM36.5676 30.0005L37.4238 27.7625L38.2798 30.0005H36.5676Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 26.9187V25.5H56.3066H56.2944H54.7656V33.107H56.3066V33.0948H60.0001V31.6761H56.3066V29.9639H59.4131V28.5453H56.3066V26.9187H60.0001Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZinzane);
export default __webpack_public_path__ + "static/media/zinzane.256b57e2cc77dd62d2a937935a068f6f.svg";
export { ForwardRef as ReactComponent };